<template>
  <a-modal
    :width="1000"
    :visible="visible"
    title="详情"
    @ok="cancel"
    @cancel="cancel"
  >
    <a-descriptions title="教师详情" :column="2" bordered>
      <a-descriptions-item label="教师姓名">
        {{ modal.name }}
      </a-descriptions-item>
      <a-descriptions-item label="角色">
        {{ modal.roleName }}
      </a-descriptions-item>
      <a-descriptions-item label="科目">
        {{ modal.subjectNames ? modal.subjectNames.replace(/\[|]/g, "") : "" }}
      </a-descriptions-item>
      <a-descriptions-item label="联系方式">
        {{ modal.mobile }}
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      //modal
      visible: false,
      modal: {},

      list: []
    };
  },
  methods: {
    show(modal) {
      // console.log(" === teacher detail @ detail task resource list: ", modal);

      this.visible = true;

      if (modal) {
        this.modal = modal;
      }
    },
    cancel() {
      this.visible = false;
      this.modal = {};
    }
  }
};
</script>
<style lang="less" scoped></style>
